export const COMPANY_NAME = 'Medditourindia Professional Pvt Ltd';
export const COMPANY_FOOTER_BRAND_LINES = ['Medditourindia', 'Professional Pvt Ltd'];
export const COMPANY_DOMAIN = 'medditourindia.com';
export const COMPANY_EMAIL = `info@${COMPANY_DOMAIN}`;
export const COMPANY_WEBSITE = `https://www.${COMPANY_DOMAIN}`;
export const COMPANY_INSTAGRAM = 'https://www.instagram.com/medditourindia';
export const COMPANY_LOCATION = 'Kochi, Kerala, India';
export const COMPANY_PHONES = [
  {
    display: '+91-7560843491',
    tel: 'tel:+917560843491',
  },
  {
    display: '+91-8892880000',
    tel: 'tel:+918892880000',
  },
];
export const COMPANY_PHONE_DISPLAY = COMPANY_PHONES.map((phone) => phone.display).join(', ');
export const COMPANY_PHONE_TEL = COMPANY_PHONES[0].tel;
export const COMPANY_WHATSAPP = 'https://wa.me/917560843491';
